import { render, staticRenderFns } from "./MiniMap.component.vue?vue&type=template&id=c523a3bc&"
import script from "./MiniMap.component.vue?vue&type=script&lang=js&"
export * from "./MiniMap.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports